import * as HttpService from './HttpService'

let namespace = 'project-types'

let development = (params, cb, errorCb) => {
    HttpService.get(namespace + '/development', params, cb, errorCb)
}

let findAll = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

let skills = (uuid, params, cb, errorCb) => {
    HttpService.get(namespace + '/' + uuid + '/main-employees', params, cb, errorCb)
}

let projectTypeSkills = (params, cb, errorCb) => {
    HttpService.get('project-types-skills', params, cb, errorCb)
}

let coveragePerHour = (params, cb, errorCb) => {
    HttpService.get(namespace + '/coverage-per-hour', params, cb, errorCb)
}

export {
    development,
    findAll,
    skills,
    projectTypeSkills,
    coveragePerHour
}



// WEBPACK FOOTER //
// ./src/services/projectTypeService.js